<template>
  <div v-if="internalBreadcrumb.length > 0" class="p-the-header-breadcrumb">
    <ol class="p-the-header-breadcrumb__list">
      <li
        v-for="({ url, text, pageType }, key) in internalBreadcrumb"
        class="p-the-header-breadcrumb__list__item"
        :key="key"
      >
        <BreadcrumbLink
          :url="url"
          :last-element="key === lastElementKey"
          :text="text"
          :page-type="pageType"
          :item-key="key"
        />
      </li>
    </ol>
  </div>
</template>

<script lang="ts">
import { mapState } from "vuex";
import BreadcrumbLink from "@/common/components/atoms/BreadcrumbLink.vue";
import { Options, Vue } from 'vue-class-component';
import commons from "@/common/store/modules/commons";

@Options({
  components: { BreadcrumbLink }
})
export default class TheBreadcrumb extends Vue {
  breadcrumb = commons.breadcrumb;
  get lastElementKey() {
    return commons.breadcrumb.length - 1;
  }

  get internalBreadcrumb() {
    return commons.breadcrumb.filter((v: any) => v);
  }
}
</script>

<style lang="scss" scoped>
.p-the-header-breadcrumb {
  padding: rem(12) 0;

  &__list {
    &__item {
      display: inline-block;
      vertical-align: middle;

      &:nth-of-type(2) {
        margin-left: rem(-4);
      }
    }
  }
}
</style>
